export interface CategoryPreview {
    titleKey: string;
    videoSrc: string;
    posterSrc: string;
    href: string;
    overlayColor?: string;
}

export const CATEGORY_PREVIEWS: CategoryPreview[] = [
    {
        titleKey: 'architecture_interior_design',
        videoSrc:
            'https://fiverr-res.cloudinary.com/video/upload/v1/video-attachments/generic_asset/asset/babe32094c80022262d182ce99ecc453-1762251566949/02_Architecture%20_%20interior%20design',
        posterSrc:
            'https://fiverr-res.cloudinary.com/video/upload/f_auto,q_auto/v1/video-attachments/generic_asset/asset/babe32094c80022262d182ce99ecc453-1762251566949/02_Architecture%20_%20interior%20design.png',
        href: '/categories/graphics-design/architectural-design-services',
        overlayColor: '96, 105, 0',
    },
    {
        titleKey: 'website_design',
        videoSrc:
            'https://fiverr-res.cloudinary.com/video/upload/v1/video-attachments/generic_asset/asset/0efc0086d96d69055715314644a24202-1762251683366/08_Website%20design',
        posterSrc:
            'https://fiverr-res.cloudinary.com/video/upload/f_auto,q_auto/v1/video-attachments/generic_asset/asset/0efc0086d96d69055715314644a24202-1762251683366/08_Website%20design.png',
        href: '/categories/graphics-design/website-design',
        overlayColor: '184, 101, 9',
    },
    {
        titleKey: 'book_publishing',
        videoSrc:
            'https://fiverr-res.cloudinary.com/video/upload/v1/video-attachments/generic_asset/asset/c8002cc0073f722b3c3a4d8755275378-1762251621460/03_Book%20design',
        posterSrc:
            'https://fiverr-res.cloudinary.com/video/upload/f_auto,q_auto/v1/video-attachments/generic_asset/asset/c8002cc0073f722b3c3a4d8755275378-1762251621460/03_Book%20design.png',
        href: '/cp/books-publishing',
    },
    {
        titleKey: 'video_editing',
        videoSrc:
            'https://fiverr-res.cloudinary.com/video/upload/v1/video-attachments/generic_asset/asset/2342dedf59eb39497070cc4291b6ea25-1762251670089/07_Video%20editing',
        posterSrc:
            'https://fiverr-res.cloudinary.com/video/upload/f_auto,q_auto/v1/video-attachments/generic_asset/asset/2342dedf59eb39497070cc4291b6ea25-1762251670089/07_Video%20editing.png',
        href: '/categories/video-animation/video-editing',
    },
    {
        titleKey: 'mobile_app_development',
        videoSrc:
            'https://fiverr-res.cloudinary.com/video/upload/v1/video-attachments/generic_asset/asset/ea99c823dbc46a494f522e0e9fcaa6ba-1762251640025/05_Mobile%20app%20development',
        posterSrc:
            'https://fiverr-res.cloudinary.com/video/upload/f_auto,q_auto/v1/video-attachments/generic_asset/asset/ea99c823dbc46a494f522e0e9fcaa6ba-1762251640025/05_Mobile%20app%20development.png',
        href: '/categories/programming-tech/mobile-app-services',
    },
    {
        titleKey: 'software_development',
        videoSrc:
            'https://fiverr-res.cloudinary.com/video/upload/v1/video-attachments/generic_asset/asset/1caedd8629b3a25160f28ec74bf9deeb-1762251659061/06_Software%20development',
        posterSrc:
            'https://fiverr-res.cloudinary.com/video/upload/f_auto,q_auto/v1/video-attachments/generic_asset/asset/1caedd8629b3a25160f28ec74bf9deeb-1762251659061/06_Software%20development.png',
        href: '/categories/programming-tech/software-development',
    },
    {
        titleKey: 'brand_style_guides',
        videoSrc:
            'https://fiverr-res.cloudinary.com/video/upload/v1/video-attachments/generic_asset/asset/ed901747677b617765ad9bbccb43492f-1762251629295/04_brand%20style%20guides',
        posterSrc:
            'https://fiverr-res.cloudinary.com/video/upload/f_auto,q_auto/v1/video-attachments/generic_asset/asset/ed901747677b617765ad9bbccb43492f-1762251629295/04_brand%20style%20guides.png',
        href: '/categories/graphics-design/brand-style-guides',
    },
];
